import { mapResponseToError } from './fetch-error';
import { NetworkConnectionError } from './fetch-error.types';
import { parseJsonBody } from './json-parse';
export const defaultFetch = async ({ method, requestUrl: paramsUrl, body, queryParams = {}, headers = {}, }) => {
    const traceId = headers['X-Trace-Id'];
    // We make a copy so we don't modify the original given requestUrl
    // When we log or construct exceptions we use the original so in order not to leak data
    const requestUrl = new URL(paramsUrl);
    let response;
    const requestInit = {
        method,
        headers,
    };
    for (const key in queryParams) {
        // eslint-disable-next-line @typescript-eslint/no-base-to-string -- values are intentionally stringified here; preserves master behavior
        requestUrl.searchParams.append(key, String(queryParams[key]));
    }
    if (body) {
        requestInit.body = JSON.stringify(body);
    }
    try {
        response = await fetch(requestUrl, requestInit);
    }
    catch (e) {
        const err = e;
        const error = new NetworkConnectionError({
            method,
            url: paramsUrl.toString(),
            details: {
                exception: `${err.name}: ${err.message}`,
                traceId,
                ...err,
            },
        });
        return {
            success: false,
            error,
        };
    }
    if (response.ok) {
        const body = await parseJsonBody(response);
        return {
            success: true,
            body,
        };
    }
    const error = await mapResponseToError(paramsUrl.toString(), requestInit.method, traceId, response, {});
    return {
        success: false,
        error,
    };
};
